import './SettingsSelect.scss';

interface SettingsSelectOption {
  value: string;
  label: string;
}

interface SettingsSelectProps {
  label: string;
  value: string;
  options: SettingsSelectOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function SettingsSelect({ label, value, options, onChange, disabled }: SettingsSelectProps) {
  return (
    <div className="settings-select">
      <span className="settings-select__label">{label}</span>
      <select
        className="settings-select__input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
